import dayjs from "dayjs";

export const getColsToRenderTableHeaders = (level, cols, arr) => {
  let _header = arr;

  if (cols) {
    cols.forEach((col, colIndex) => {
      const { childs, ...rest } = col;
      const colSpan = childs?.length ?? 1;
      const finalColObj = { span: colSpan, ...rest };

      if (_header[level]) {
        _header[level].push(finalColObj);
      } else {
        _header[level] = [finalColObj];
      }
      getColsToRenderTableHeaders(level + 1, col.childs ?? null, _header);
    });
  } else {
    // if (_header[level]) {
    //     _header[level].push(cols);
    //   } else {
    //     _header[level] = [cols];
    //   }
  }

  return _header.filter((head) => !head.every((col) => col == null));
};

export function getLast12Months(ts) {
  const months = [];
  const currentDate = new Date(ts);
  for (let i = 0; i < 12; i++) {
    const monthTimestamp = currentDate.getTime();
    const monthName = currentDate.toLocaleString("default", {
      month: "long",
      year: "numeric",
    });

    months.push({
      id: monthTimestamp,
      label: monthName,
    });
    currentDate.setMonth(currentDate.getMonth() - 1);
  }

  return months;
}

export const getFormattedRowData = (formJson, rawdata) => {
  const _formattedData = [];
  formJson.forEach((colInfo) => {
    const { key, type } = colInfo;
    let rawVal = rawdata?.[key] ?? null;
    if (rawVal && type?.validator) {
      const valObj = type.validator;
      if (valObj.is_integer || valObj.is_numeric) {
        rawVal = Number(rawVal) ?? null;
      }
    }
    if (type?.field === "attachment" || type?.field === "dropdown") {
      if (Array.isArray(rawVal)) {
        rawVal = rawVal.length > 0 ? rawVal : null;
      } else {
        rawVal = null;
      }
    }
    _formattedData.push({ key: key, val: rawVal });
    // _formattedData[key] = rawVal
  });
  return _formattedData;
};

export const shouldShowAddButton = (is_growable, annexureInfo, user) => {
  const { is_derived, derived_from } = annexureInfo;
  return is_growable && (is_derived === false || user?.group?.entity === derived_from);
};
export const shouldDisableEditButtion = (user, annexureInfo) => {
  const { is_derived, derived_from } = annexureInfo;
  return !(is_derived === false || user?.group?.entity === derived_from);
};

export const getValidSerchableKeys = (columns) => {
  const _keys = [];
  columns.forEach((col) => {
    const { key, field } = col;
    if (["textbox", "dropdown"].includes(field)) {
      _keys.push(key);
    }
  });
  return _keys;
};

export const getDataColumns = (
  initCols,
  colArray,
  parentFlex = 1,
  parentMinWidth = 10,
  // widthFraction=10
) => {
  let _cols = [...initCols];
  colArray.forEach((colObj) => {
    let flex = colObj.flex !== undefined ? colObj.flex : parentFlex;
    const minWidth = colObj.minWidth !== undefined ? colObj.minWidth : parentMinWidth;
    const { childs, ...rest } = colObj;
    if (childs) {
      flex /= childs.length;
      _cols = getDataColumns(_cols, childs, flex, minWidth);
    } else {
      _cols.push({ ...rest, flex, minWidth });
    }
  });
  return _cols;
};
// export const getDataColumns = (
//   initCols,
//   colArray,
//   parentFlex = 1,
//   parentMinWidth = 10
// ) => {
//   let _cols = [...initCols];
//   colArray.forEach((colObj) => {
//     let flex = colObj.flex !== undefined ? colObj.flex : parentFlex;
//     const minWidth =
//       colObj.minWidth !== undefined ? colObj.minWidth : parentMinWidth;
//     const { childs, ...rest } = colObj;
//     if (childs) {
//       flex /= childs.length;
//       _cols = getDataColumns(_cols, childs, flex, minWidth);
//     } else {
//       _cols.push({ ...rest, flex, minWidth });
//     }
//   });
//   return _cols;
// };

export const getFormattedCellText = (colInfo, cellText) => {
  if (cellText) {
    let _text = cellText;
    const fieldType = colInfo?.field;
    if (fieldType === "datepicker" || fieldType === "datetimepicker") {
      const numTs = Number(cellText);
      if (numTs || numTs === 0) {
        _text = dayjs(numTs).format("DD/MM/YYYY");
      } else {
        _text = "-";
      }
    }
    if (fieldType === "attachment") {
      if (Array.isArray(_text)) {
        _text = _text.map((filePath) => {
          const [id, ...rest] = filePath.split("_");
          return rest;
        });
      } else {
        _text = "-";
      }
    }
    if (colInfo?.suffix) {
      _text = `${_text} (${colInfo.suffix})`;
    }
    if (colInfo?.prefix) {
      _text = `${colInfo?.prefix} ${_text}`;
    }
    return _text;
  } else {
    return "-";
  }
};

export const getGroupIdsDropDownlist = (parentId, groupsData) => {
  console.log("groupsData", groupsData);
  const _dd = [];
  groupsData.forEach((group) => {
    if (group.parent_id === parentId) {
      const dd_obj = {
        id: group.id,
        label: group.code,
      };
      _dd.push(dd_obj);
    }
  });
  return _dd;
};
